import React from 'react';
import styled from 'styled-components';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const FooterContainer = styled.footer`
  background-color: #1a202c;
  color: #cbd5e0;
  padding: 3rem 0;
`;

const ContentWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Section = styled.div`
  h3 {
    color: white;
    font-size: 1.125rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;

  svg {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
    margin-top: 0.25rem;
  }
`;

const LinksList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-bottom: 0.5rem;
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: white;
    }
  }
`;

const AboutText = styled.p`
  font-size: 0.875rem;
  line-height: 1.5;
`;

const Copyright = styled.div`
  border-top: 1px solid #2d3748;
  margin-top: 2rem;
  padding-top: 2rem;
  text-align: center;
  font-size: 0.875rem;
`;

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <ContentWrapper>
        <GridContainer>
          {/* Contact Information */}
          <Section>
            <h3>{t('footer.contact.title')}</h3>
            <ContactItem>
              <MapPin />
              <p>{t('footer.contact.address')}</p>
            </ContactItem>
            <ContactItem>
              <Phone />
              <p>+992 44 600 70 18</p>
            </ContactItem>
            <ContactItem>
              <Mail />
              <p>abt_it@abt.tj </p>
            </ContactItem>
            <ContactItem>
              <Clock />
              <p>
                {t('footer.contact.workingHours.weekdays')}<br />
                {t('footer.contact.workingHours.weekend')}
              </p>
            </ContactItem>
          </Section>

          {/* Quick Links */}
          <Section>
            <h3>{t('footer.quickLinks.title')}</h3>
            <LinksList>
              <li><Link to="/about-us">{t('footer.quickLinks.about')}</Link></li>
              <li><Link to="/members">{t('footer.quickLinks.members')}</Link></li>
      
            </LinksList>
          </Section>

          {/* About */}
          <Section>
            <h3>{t('footer.about.title')}</h3>
            <AboutText>
              {t('footer.about.description')}
            </AboutText>
          </Section>
        </GridContainer>

        <Copyright>
            <p>Сайт разработан <a style={{color:"#fff"}} href='https://amonniy.site'>Amonniy Systems</a></p>
          <p>{t('footer.copyright', { year: currentYear })}</p>
        </Copyright>
      </ContentWrapper>
    </FooterContainer>
  );
};

export default Footer;